import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"10px"}
}
const _hoisted_2 = { class: "row g-3" }

import GalleryV2Loader from "@/components/GalleryV2Loader.vue";
import {computed} from "vue";
import {useStore} from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'Impressions',
  setup(__props) {

const store = useStore()

const hasImpressions = computed(() => {
  return store.getters['hasImpressions'];
});

return (_ctx: any,_cache: any) => {
  return (hasImpressions.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "headline cb-headlinenormalxl g-3 mb-4" }, " Impressions ", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GalleryV2Loader, {
            url: '/webapp/imageslider2/',
            class: "light-gray"
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
      ]))
    : _createCommentVNode("", true)
}
}

})